import { Accordion, Button, Grid, styled } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export const CardMainContainer = styled(Grid)`
  overflow-y: auto;
  max-height: calc(100vh - 130px);
  justify-content: flex-start;
  scrollbar-width: none; // this part hides the scrollbar for Firefox browser
  -ms-overflow-style: none; // this for  IE/Edge

  // this for hiding scrollbar on WebKit-based browsers */
  &::-webkit-scrollbar {
    display: none;
  }

  .delete-wrapper {
    border-radius: 20px;
    border: 1px solid #efefef;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
    width: 36px;
    height: 36px;
    padding: 0px 16px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    cursor: pointer;
  }

  .status {
    text-transform: capitalize;
  }
  .title {
    color: #000;
    font-size: 20px;
    font-weight: 500;
    line-height: 19.36px;
  }
  .desc {
    color: var(--Neutral-500, #667085);
    font-size: 14px;
    font-weight: 400;
    line-height: 14.52px;
  }
`;

export const CardWrapper = styled(Grid)`
  border-radius: 8px;
  border: 1px solid var(--Silver-200, #e3e3e3);
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.12);
  padding: 24px;

  .title {
    color: #000;
    font-size: 20px;
    font-weight: 500;
  }
  .desc {
    color: var(--Neutral-500, #667085);
    font-size: 14px;
    font-weight: 400;
  }

  .edit-wrapper {
    padding: 8px 16px;
    border-radius: 20px;
    border: 1px solid #efefef;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
    cursor: pointer;
  }

  .delete-wrapper {
    border-radius: 50%;
    border: 1px solid #efefef;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
    padding: 10px;
    cursor: pointer;
  }

  .button {
    border-radius: 20px;
    padding: 0 12px;
    /* border: 1px solid #fff; */
    /* padding: 8px; */
    background: linear-gradient(180deg, #222124 23.75%, #323232 120%);
  }

  .icon {
    margin-top: 5px;
  }

  .questions-title {
    color: #000;
    font-size: 14px;
    font-weight: 500;
  }
  .question {
    color: var(--Neutral-900, #101828);
    font-size: 12px;
    font-weight: 500;
  }
  .question-wrapper {
    border-radius: 4px;
    background: var(--Neutral-100, #f2f4f7);
    padding: 8px;
  }
`;

export const EditWrapper = styled(Grid)`
  background: #fff;
  .label {
    color: var(--Neutral-900, #101828);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .title {
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .button {
    width: 100%;
    border-radius: 20px;
  }

  .text-area {
    width: 100%;
    border-radius: 4px;
    border: 1px solid var(--Neutral-200, #e4e7ec);
    background: var(--Neutral-0, #fff);
    color: var(--Neutral-500, #667085);
    font-size: 14px;
    font-weight: 400;

    /* Input Shadow */
    box-shadow: 1px 2px 2px 0px rgba(16, 24, 40, 0.12) inset;
  }

  .custom-input {
    border-radius: 4px;
    border: 1px solid var(--Neutral-200, #e4e7ec);
    background: var(--Neutral-0, #fff);
    padding: 10px;

    /* Input Shadow */
    box-shadow: 1px 2px 2px 0px rgba(16, 24, 40, 0.12) inset;
  }

  .custom-input-error {
    border-radius: 4px;
    border: 1px solid var(--Neutral-200, red);
    background: var(--Neutral-0, #fff);
    padding: 10px;

    /* Input Shadow */
    box-shadow: 1px 2px 2px 0px rgba(16, 24, 40, 0.12) inset;
  }

  .mandatory-text {
    color: red;
    font-size: 12px;
    position: relative;
  }

  .icon {
    cursor: pointer;
    margin: 5px 0 0 0;
  }

  .question-modal-help {
    padding: 0 16px;
    font-size: 12px;
    color: #666;

    & .question-modal-help-list {
      margin: 0;
      padding: 0 0 0 16px;
    }

    & .question-modal-help-example {
      font-weight: 500;
      color: #000;
    }
  }
`;

export const DeleteWrapper = styled(Grid)`
  .title {
    color: #000;
    font-size: 14px;
    font-weight: 500;
  }

  .card-title {
    color: #000;
    font-size: 20px;
    font-weight: 500;
  }

  .sub-title {
    color: var(--Neutral-500, #667085);
    font-size: 12px;
    font-weight: 500;
  }

  .button {
    width: 100%;
    border-radius: 20px;
  }
`;

export const ParentContainer = styled(Grid)`
  width: 100%;
  justify-content: flex-start;
  overflow: auto;
`;

export const PendingWrapper = styled(Grid)`
  border-radius: 8px;
  border: 1px solid var(--Silver-200, #e3e3e3);
  background: var(--Neutral-100, #f2f4f7);
  padding: 16px;
  .pending-title {
    color: #000;
    font-size: 15px;
    font-weight: 500;
  }

  .pill-text {
    color: #d6a614;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 133.333% */
  }

  .status {
    color: var(--Neutral-500, #667085);
    font-size: 15px;
    font-weight: 500;
  }

  .pill {
    border-radius: 12px;
    border: 1px solid #f4d269;
    background: #fcf4db;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
  }
`;

export const FileWrapper = styled(Grid)`
  border-radius: 8px;
  border: 1px solid var(--Neutral-200, #e4e7ec);
  background: var(--Neutral-100, #f2f4f7);
  height: fit-content;
  box-shadow: none;
  margin-bottom: 10px;
`;
export const StyledAccordion = styled(Accordion)`
  width: 100%;
  border-radius: 8px;
  border: 1px solid var(--Neutral-200, #e4e7ec);
  background: var(--Neutral-100, #f2f4f7);
  box-shadow: none;
`;

export const Container = styled(Grid)`
  width: 100%;
  display: flex;
  border-radius: 8px;
  gap: 16px;
  height: 320px;
`;

export const UploadButton = styled(Button)`
  border-radius: 4px;
  background: #182e4b;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  padding: 10px;
  height: 2rem;
`;

export const CancelButton = styled(Button)`
  border-radius: 4px;
  border: 1px solid #182e4b;
  color: #182e4b;
  height: 2rem;
  font-size: 14px;
  font-weight: 500;
  width: 100px;
`;

export const ButtonParent = styled(Grid)`
  display: flex;
  justify-content: space-between;
  gap: 4px;
  @media (max-width: 1199px) {
    flex-direction: column;
    align-items: center;
  }
  gap: 8px;
`;

export const QuestionButton = styled(Button)`
  width: 100%;
  background: linear-gradient(180deg, #222124 23.75%, #323232 120%);
  color: #fff;
  border-radius: 20px;
  text-transform: none;
  height: 38px;
`;

export const AddIconWrapper = styled(AddIcon)`
  height: 20px;
  width: 20px;
  align-items: center;
  margin-right: 3px;
`;

export const Text = styled('p')`
  font-size: 12px;

  @media (min-width: 900px) {
    font-size: 14px;
  }
`;
